import { Checkbox, Dialog, type DialogRef } from '@myosh/odin-components';
import { type Ref, useState } from 'react';

interface AiAnalysisConfirmationModalProps {
  handleSubmitConfirmation: (value: boolean) => void;
  handleCloseModal: () => void;
  ref?: Ref<DialogRef>;
}

const AiAnalysisConfirmationModal = ({
  handleSubmitConfirmation,
  handleCloseModal,
  ref,
}: AiAnalysisConfirmationModalProps) => {
  const [isAiAnalysisConfirmationCheckboxChecked, setIsAiAnalysisConfirmationCheckboxChecked] = useState(false);

  return (
    <Dialog
      data-cy="ai-analysis-confirmation-modal"
      buttons={[
        {
          name: 'submit',
          text: 'Ok',
          type: 'primary',
          onClick: () => handleSubmitConfirmation(isAiAnalysisConfirmationCheckboxChecked),
        },
        {
          name: 'cancel',
          text: 'Cancel',
          type: 'default',
          variant: 'alternative',
          onClick: handleCloseModal,
        },
      ]}
      header={''}
      ref={ref}
    >
      <div className="flex flex-col gap-4">
        <p className="text-lg font-semibold">
          Warning: Data is sent to an external AI. Verify all AI results for accuracy.
        </p>
        <Checkbox
          data-cy="ai-analysis-confirmation-checkbox"
          name="show-ai-analysis-confirmation"
          label="Don’t show me again"
          checked={isAiAnalysisConfirmationCheckboxChecked}
          onChange={(value) => setIsAiAnalysisConfirmationCheckboxChecked(value!.checked)}
        />
      </div>
    </Dialog>
  );
};

export default AiAnalysisConfirmationModal;
